var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
import { generateSrc } from "./generateSrc";
var isValidFixedValue = /* @__PURE__ */ __name(function isValidFixedValue2(value, fixedDimensionKey) {
  if (Number.isNaN(value)) {
    console.error("[generateSrcSet] Art direction configuration is not setup properly. Expected fixed dimension '".concat(fixedDimensionKey, "' to have numeric value, but received ").concat(value));
    return false;
  }
  return true;
}, "isValidFixedValue");
var generateSrcSet = /* @__PURE__ */ __name(function generateSrcSet2(baseUrl, imageKey, extension) {
  var artDirectionConfig = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  var maxDimension = arguments.length > 4 ? arguments[4] : void 0;
  var fixedBy = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "width";
  if (!artDirectionConfig || !artDirectionConfig.length) {
    console.error("[generateSrcSet] The artDirectionConfig config property should not be empty.");
  }
  var fixedDimensionKey = fixedBy === "height" ? "height" : "width";
  var filteredArtDirectionConfig = _toConsumableArray(artDirectionConfig);
  if (maxDimension) {
    var maxDimensions = null;
    filteredArtDirectionConfig = artDirectionConfig.filter(function(item) {
      var fixedDimensionValue = parseInt(item[fixedDimensionKey], 10);
      if (fixedDimensionValue < maxDimension) {
        if (!maxDimensions || maxDimensions && parseInt(maxDimensions[fixedDimensionKey], 10) < fixedDimensionValue) {
          maxDimensions = _objectSpread({}, item);
        }
        return true;
      }
      return false;
    });
    if (maxDimensions && artDirectionConfig.length !== filteredArtDirectionConfig.length) {
      var oppositeKey = fixedBy === "width" ? "height" : "width";
      if (typeof maxDimensions[oppositeKey] === "string" && maxDimensions[oppositeKey].toUpperCase() === "AUTO") {
        filteredArtDirectionConfig.push(_defineProperty(_defineProperty({}, fixedDimensionKey, maxDimension), oppositeKey, "AUTO"));
      }
    }
  }
  return filteredArtDirectionConfig.map(function(item) {
    var intrinsicWidth = parseInt(item[fixedDimensionKey], 10);
    if (!isValidFixedValue(intrinsicWidth, fixedDimensionKey)) {
      return "";
    }
    return "".concat(generateSrc(baseUrl, {
      key: imageKey,
      width: item.width,
      height: item.height,
      extension
    }), " ").concat(intrinsicWidth, "w");
  });
}, "generateSrcSet");
export {
  generateSrcSet
};
